import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { isValidArray } from 'helpers/validation';
import service from 'pages/ScheduleCalendar/duck/service';
import { Mixpanel } from 'helpers/Mixpanel';
import './DetailFieldSkillComponent.scss';

export function DetailFieldSkillComponent({ 
  skills, 
  selectSkills, 
  disableField, 
  selectedSkills = [],
  groupToPostTo,
  allUsers = [],
  channelMembers = []
}) {
  // Debug: Log when props change
  useEffect(() => {
  }, [groupToPostTo, channelMembers, allUsers]);
  const handleSkillToggle = (skill,e) => {
    e.stopPropagation();
    const isSelected = selectedSkills.some(selectedSkill => selectedSkill.id === skill.id);
    
    if (isSelected) {
      // Remove skill
      const updatedSkills = selectedSkills.filter(selectedSkill => selectedSkill.id !== skill.id);
      selectSkills(updatedSkills);
      Mixpanel.track('Remove skill', { 
        skill_id: skill.id, 
        skill_content: skill.skill_content 
      });
    } else {
      // Add skill
      const updatedSkills = [...selectedSkills, skill];
      selectSkills(updatedSkills);
      Mixpanel.track('Add skill', { 
        skill_id: skill.id, 
        skill_content: skill.skill_content 
      });
    }
  };

  const getSkillUserCount = (skill) => {
    const membersToUse = channelMembers.length > 0 ? channelMembers : [];
    const count = service.findSkilledUsersInCurrentChannel(skill, groupToPostTo, membersToUse).length;
    return count;
  };

  const postableSkillList = () => {
    if (!isValidArray(skills)) {
      return (
        <li className='dropdown-li no-skills'>
          <div className="skill-option-content">
            <label>No skills available</label>
          </div>
        </li>
      );
    }

    const sortedSkills = [...skills].sort((a, b) => {
      if (a.skill_content > b.skill_content) return 1;
      if (a.skill_content < b.skill_content) return -1;
      return 0;
    });

    return sortedSkills.map((skill) => {
      const isSelected = selectedSkills.some(selectedSkill => selectedSkill.id === skill.id);
      const userCount = getSkillUserCount(skill);
      
      return (
        <li 
          className={`dropdown-li ${isSelected ? 'selected' : ''}`} 
          key={skill.id} 
          onClick={(e) => handleSkillToggle(skill,e)}
        >
          <div className="skill-option-content">
            <label>{skill.skill_content}</label>
            {userCount > 0 && (
              <span className="skill-member-count">{userCount} {userCount === 1 ? 'member' : 'members'}</span>
            )}
            {isSelected && <img src="/icons/blue-check-mark.svg" alt="Checked" className="skill-checkbox-icon" />}
          </div>
        </li>
      );
    });
  };

    const renderSelectedSkills = () => {
    if (!selectedSkills || selectedSkills.length === 0) {
      return <span className="placeholder-text">{ disableField ? 'None': 'Select skills'}</span>;
    }

    return (
      <div className="selected-skills-display">
        {selectedSkills.map((skill, index) => (
          <span key={skill.id} className="selected-skill-item">
            {skill.skill_content}
            {index < selectedSkills.length - 1 && <span className="skill-separator">, </span>}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="detail-field-skill">
      <div className="title-label">Skills</div>
      <button 
        disabled={disableField} 
        id="dropdownMenuButtonSkills" 
        className="header-button skill-header skill-placeholder" 
        type="button" 
        data-bs-toggle="dropdown" 
        aria-expanded="false"
      >
        {renderSelectedSkills()}
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButtonSkills">
        {postableSkillList()}
      </ul>
    </div>
  );
}

export default injectIntl(DetailFieldSkillComponent);
